import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' //Vuesax styles
import VueSignaturePad from 'vue-signature-pad';
import VueResource from 'vue-resource'

const mode = process.env.VUE_APP_MODE

Vue.use(Vuesax, {})
Vue.use(VueSignaturePad);
Vue.use(VueResource)
Vue.http.options.root = (mode === 'production' || mode === 'testing') ? 'https://sign.justconsult.md/api/':'http://localhost/server/api/v2/'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
